import { Button } from 'blaze-ui/Button'
import { Copy, ArrowRefresh2, Edit1 } from 'blaze-ui/icons'
import Styles from '../GeneratedContent.module.scss'

interface ActionButtonsProps {
  displayedCaption: string
  hasError: boolean
  streaming: boolean
  allOptions: string[]
  onCopy: () => void
  onRegenerate: () => void
  onOpenInWriter: () => void
}

export const ActionButtons = ({
  displayedCaption,
  hasError,
  streaming,
  allOptions,
  onCopy,
  onRegenerate,
  onOpenInWriter,
}: ActionButtonsProps) => {
  return (
    <>
      <Button variant="primary" onPress={onCopy} frontIcon={Copy} fullWidth isDisabled={!displayedCaption || hasError}>
        Copy
      </Button>
      <div className={Styles.actionButtonsRow}>
        <Button
          className={Styles.actionButton}
          variant="tertiary"
          onPress={onRegenerate}
          frontIcon={() => <ArrowRefresh2 size={28} />}
          isDisabled={streaming}
        >
          Regenerate
        </Button>
        <Button
          className={Styles.actionButton}
          variant="tertiary"
          onPress={onOpenInWriter}
          frontIcon={() => <Edit1 size={28} />}
          isDisabled={!displayedCaption || hasError}
        >
          Open in Writer
        </Button>
      </div>
    </>
  )
}
